import styled from 'styled-components';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import { Image } from '@/shared/ui/image';
import { useBrandTheme } from '@/shared/hooks';

export const LicenseBlock = () => {
  const t = useScopedI18n('common.footer');
  const { isMillion } = useBrandTheme();

  if (isMillion) {
    return null;
  }

  const url =
    'https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJa3RtTWxVeGVWcHpOVkI2Tm1KcGFuWnBaMkpUWTBFOVBTSXNJblpoYkhWbElqb2lUVzUwWTIxdWFsQjBVbHB4Y1ZoclJVRlNiRTE1Ym5KUFoySnVja2RrUmtVME0zTTRlbkYxUVdGQ1NUMGlMQ0p0WVdNaU9pSTVPR1ZoWm1ReU9UWTRaamc0WXpsbFltRXdaRFl3WVdGaE56Um1OVE01WlRBeE9EWmhZelU0TjJFNFpERTJZVEV3WmpNd01qUTRNalJqT1dFeVpUaGhJaXdpZEdGbklqb2lJbjA9';
  return (
    <BlockWrapper>
      <BodyTextRegularB color="#AFAFAF">
        {t('license_title').toUpperCase()}
      </BodyTextRegularB>
      <AButton href={url} target="_blank" rel="nofollow">
        <Image
          src={'/images/icons/footer/GCB_Seal.svg'}
          alt={'license'}
          width={80}
          height={55}
        />
      </AButton>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 70px;
  gap: 12px;
`;
const AButton = styled.a`
  width: 80px;
  height: 55px;
`;
